import { createElement } from "react";
import React from "react";
import * as react from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import FilterList from "@mui/icons-material/FilterList";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export function Components_Filterbar_Z27381C84(components_Filterbar_Z27381C84InputProps) {
    let elems, props_1;
    const expandable = components_Filterbar_Z27381C84InputProps.expandable;
    const expanded = components_Filterbar_Z27381C84InputProps.expanded;
    const children = components_Filterbar_Z27381C84InputProps.children;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        padding: ((((((10 + "px ") + 15) + "px ") + 10) + "px ") + 15) + "px",
        gap: 10 + "px",
        borderRadius: 4 + "px",
        border: (((1 + "px ") + "solid") + " ") + "var(--grey)",
    }], (elems = [(props_1 = {}, react.createElement(FilterList, props_1)), children], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

